import { InfiniteData } from '@tanstack/query-core';
import { useMutation } from '@tanstack/react-query';
import { type ArticlesPaginatedList } from '@shared/types/articles';
import { API } from '@src/api/index.ts';
import { queryClient } from '@src/api/query-client.ts';
import { EntityByIdParam } from '@src/api/types.ts';

export const useDeleteArticleMutation = () => {
  return useMutation({
    mutationFn: async (params: EntityByIdParam) => await API.articles.delete(params),
    onSuccess: (response, { id }) => {
      queryClient.setQueriesData(
        { queryKey: ['articles'] },
        (oldData: InfiniteData<ArticlesPaginatedList>) => {
          if (!oldData) return oldData;
          return {
            ...oldData,
            pages: oldData.pages.map((page) => ({
              ...page,
              results: [...page.results.filter((item) => item.id !== Number(id))],
            })),
          };
        }
      );
      queryClient.invalidateQueries({ queryKey: ['articles'] });
    },
  });
};
